// extracted by mini-css-extract-plugin
module.exports = {"ticket-card-layout":"ticketCard_ticket-card-layout__YMmlZ","type":"ticketCard_type__6Zhh9"};